import { render, staticRenderFns } from "./TabelaParecerDescritivo.vue?vue&type=template&id=0e7de34c&"
import script from "./TabelaParecerDescritivo.vue?vue&type=script&lang=js&"
export * from "./TabelaParecerDescritivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports